//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import COLOR from "utils/constants/color";

//  -- Features -----------------------

//  -- Thunks -------------------------
import SpinLoader from "components/Loader/SpinLoader";
import { handleListPlacementexam } from "store/placement_exam/thunks";
import PlacementExamList from "./PlacementExamList";
import { ArchivePlacement } from "./archivePlacementList";
import Rubric from "modules/adminRubricModule";
import * as Sentry from '@sentry/react';
import { useHasPermission } from 'utils/permissions';
import { message } from 'antd';

const MENU = [{ id: "placement_exam", value: "Placement Exam" },{id: "archive_placement", value: "Archive Placement Exam"},{ id: "rubrics", value: "Placement Rubrics" }];


const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
//   justify-content: space-between;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
//   border: 2px solid ${COLOR.black100};
//   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;
const MenuBtn = styled.button`
  background-color:white;
  border-top:none;
  border-left:none;
  border-right:none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;

export default function PlacementExam({}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const hasViewPlacementExam = useHasPermission('placement_exam.view');
  const hasRubricsManagement = useHasPermission('placement_exam.rubrics_management');
  const hasArchivePlacement = useHasPermission('placement_exam.archive_placement');
  const [dataTab,setDataTab] = useState("placement_exam");
  const [loading, setLoading] = useState(false);

  const checkPermission = (id) => {
    if (id === 'placement_exam') return hasViewPlacementExam;
    else if (id === 'rubrics') return hasRubricsManagement;
    else if (id === 'archive_placement') return true;
    return false;
  };

  async function listExam(){
    setLoading(true);
    try {
      await dispatch(handleListPlacementexam())
    } catch (error) {
      Sentry.captureException(`437 Error in listExam: ${error}`);
      console.error(error,"error in loading placement exam")
    } finally{
      setLoading(false);
    }
  }
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        await getCurrentUser();
        await listExam()
        setLoading(false);
      } catch {
        navigate("/");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (MENU.length > 0 && !MENU.find(item => item.id === dataTab)) {
      setDataTab(MENU[0].id);
    }
  }, [dataTab]);

  const navigationToMenu = (id) => {
    if (!checkPermission(id)) {
      message.warning('You do not have permission to access this feature.');
      return;
    }
    setDataTab(id);
  };

  return (
    <SentryWrap>
      <SpinLoader dataloader={loading} />
      <Wrapper className={"adminForm"}>
        <MenuWrapper top={"10px"} style={{ width: "100%" }}>
          {MENU.map((x) => (
            <MenuBtn
              style={{
                borderBottom:
                  dataTab === x?.id
                    ? "5px solid rgb(28,49,115)"
                    : "5px solid #fcfcfc",
                color: dataTab === x?.id ? "rgb(28,49,115)" : "black",
              }}
              key={x.id}
              onClick={() => navigationToMenu(x.id)}
            >
              {x.value}
            </MenuBtn>
          ))}
        </MenuWrapper>
        {hasViewPlacementExam && dataTab == MENU[0].id && (
          <PlacementExamList
            userloading={loading}
          />
        )}
        {hasArchivePlacement && dataTab == MENU[1].id && (
          <ArchivePlacement
            from={"placement"}
          />
        )}
        {hasRubricsManagement && dataTab == MENU[2].id && (
          <Rubric
            from={"placement"}
          />
        )}
      </Wrapper>
    </SentryWrap>
  )
}
